module.exports = __webpack_public_path__ + "img/knu2_gallery16.4856faa9.jpg";